import React, { useEffect, useState } from 'react';
import Money from 'js-money';
import InstantApprovalInfoBox from '../location/map/InstantApprovalInfoBox';
import RequestSpaceInfoBox from '../location/map/RequestSpaceInfoBox';
import AtCapacityInfoBox from '../location/map/AtCapacityInfoBox';
import { OverlayView } from '@react-google-maps/api';
import { DAYS_PER_MONTH } from '../constants/securspace-constants';
import { useFeatureFlags } from '../../hooks/routing/useFeatureFlags';
import type { Supplier } from '../../types/Supplier';

const google = window.google;

interface LocationMarkerProps {
  location: Supplier;
  onLocationSelect: (location: Supplier) => void;
  listHover?: Supplier | null;
}

const LocationMarker = (props: LocationMarkerProps) => {
  const { location, onLocationSelect, listHover } = props;
  const [formattedPricePerDay, setFormattedPricePerDay] = useState('');
  const { supplierCapacitySchedule } = useFeatureFlags();
  const isAtCapacity = supplierCapacitySchedule && location?.hasAvailableCapacityToday === false;

  useEffect(() => {
    const { pricePerDay, pricePerMonth } = location;
    const currencyType = Money.USD;
    // convert to money objects if exists
    const pricePerDayMoney = pricePerDay && new Money(pricePerDay, currencyType);
    const pricePerMonthToPricePerDayMoney = pricePerMonth && (new Money(pricePerMonth, currencyType)).divide(DAYS_PER_MONTH);
    // grab price per day if it exists first, then converted monthly price if not
    const actualPricePerDay = pricePerDayMoney || pricePerMonthToPricePerDayMoney;
    if (actualPricePerDay) {
      // no actual function to do ceil with money object unfortunately, so split decimals and add one if greater than 0
      // eslint-disable-next-line prefer-const
      let [pricePerDayMoniesNoDecimal, pricePerDayDecimals] = actualPricePerDay.toString().split('.');
      if (pricePerDayDecimals && parseInt(pricePerDayDecimals, 10) > 0) {
        pricePerDayMoniesNoDecimal = String(parseInt(pricePerDayMoniesNoDecimal, 10) + 1);
      }
      setFormattedPricePerDay(`${currencyType.symbol}${pricePerDayMoniesNoDecimal}`);
    }
  }, [location]);

  const handleLocationSelect = () => {
    onLocationSelect(location);
  }

  const getPixelPositionOffset = (width: number, height: number) => ({
    x: -(width / 2),
    y: -(height / 2),
  })

  return (
    <OverlayView position={new google.maps.LatLng(parseFloat(location.addressLatitude), parseFloat(location.addressLongitude))}
      mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}
      getPixelPositionOffset={getPixelPositionOffset}>
      {
        isAtCapacity ?
          <AtCapacityInfoBox listHover={location?.locationId === listHover?.locationId} formattedPrice={formattedPricePerDay} onClick={handleLocationSelect} /> :
          location?.hasInstantApproval ?
          <InstantApprovalInfoBox listHover={location?.locationId === listHover?.locationId} formattedPrice={formattedPricePerDay} onClick={handleLocationSelect} /> :
          <RequestSpaceInfoBox listHover={location?.locationId === listHover?.locationId}  formattedPrice={formattedPricePerDay} onClick={handleLocationSelect} />
      }
    </OverlayView>
  );
}

export default LocationMarker;
